import Column from '@components/Column';
import Image from '@components/Image';
import Text from '@components/Text';
import { useTranslation } from 'react-i18next';

import img from './img.png';
import styles from './styles.module.scss';

function GiftHeader() {
    const { t } = useTranslation('gift');
    return (
        <Column align='center' fullWidth
            spacing={32}
            className={styles.container}>
            <Image src={img}
                className={styles.image}
                width={224}
                alt='' />
            <Text size='3xl' fontWeight='bold'>
                {t('giftReceived.headerMessage', { name: '김찡찡' })}
            </Text>
        </Column>
    );
}

export default GiftHeader;
